// extracted by mini-css-extract-plugin
export default {"switch-wrapper":"switch-wrapper__v7j97","switch":"switch__V0yKk","pin":"pin__2MwhZ","on":"on__2iqjR"};